import React from "react";
import ResetPassword from "../../../Components/Auth/ResetPassword";

const ResetPasswordPage = (props) => <ResetPassword propsData={props} />;

export default ResetPasswordPage;
